
export default defineNuxtRouteMiddleware((_to, from) => {
  if (import.meta.server) {
    return
  }

  if (!from.name) {
    return
  }

  const rootStore = useRootStore()
  rootStore.previousRoutes.unshift({
    name: String(from.name),
    fullPath: from.fullPath,
  })

  if (rootStore.previousRoutes.length > 10) {
    rootStore.previousRoutes.pop()
  }
})